import * as React from "react"

export default ({ ...props }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.2422 0.904297C19.6447 0.904297 19.1584 1.39547 19.1584 1.99891C19.1584 2.60235 19.6447 3.09352 20.2422 3.09352C20.8397 3.09352 21.326 2.60235 21.326 1.99891C21.326 1.39547 20.8397 0.904297 20.2422 0.904297Z"
        fill="white"
      />
      <path
        d="M20.2422 5.94932C19.6447 5.94932 19.1584 6.44049 19.1584 7.04393C19.1584 7.64737 19.6447 8.13854 20.2422 8.13854C20.8397 8.13854 21.326 7.64737 21.326 7.04393C21.326 6.44049 20.8397 5.94932 20.2422 5.94932Z"
        fill="white"
      />
      <path
        d="M20.2422 10.994C19.6447 10.994 19.1584 11.4852 19.1584 12.0886C19.1584 12.692 19.6447 13.1832 20.2422 13.1832C20.8397 13.1832 21.326 12.692 21.326 12.0886C21.326 11.4852 20.8397 10.994 20.2422 10.994Z"
        fill="white"
      />
      <path
        d="M25.3357 0.904297C24.7382 0.904297 24.2519 1.39547 24.2519 1.99891C24.2519 2.60235 24.7382 3.09352 25.3357 3.09352C25.9332 3.09352 26.4195 2.60235 26.4195 1.99891C26.4195 1.39547 25.9332 0.904297 25.3357 0.904297Z"
        fill="white"
      />
      <path
        d="M25.3362 5.94932C24.7387 5.94932 24.2524 6.44049 24.2524 7.04393C24.2524 7.64737 24.7387 8.13854 25.3362 8.13854C25.9337 8.13854 26.42 7.64737 26.42 7.04393C26.42 6.44049 25.9337 5.94932 25.3362 5.94932Z"
        fill="white"
      />
      <path
        d="M25.3362 10.994C24.7387 10.994 24.2524 11.4852 24.2524 12.0886C24.2524 12.692 24.7387 13.1832 25.3362 13.1832C25.9337 13.1832 26.42 12.692 26.42 12.0886C26.42 11.4852 25.9337 10.994 25.3362 10.994Z"
        fill="white"
      />
      <path
        d="M30.3393 0.904297C29.7419 0.904297 29.2555 1.39547 29.2555 1.99891C29.2555 2.60235 29.7419 3.09352 30.3393 3.09352C30.9368 3.09352 31.4232 2.60235 31.4232 1.99891C31.4301 1.39547 30.9438 0.904297 30.3393 0.904297Z"
        fill="white"
      />
      <path
        d="M30.3398 5.94932C29.7424 5.94932 29.256 6.44049 29.256 7.04393C29.256 7.64737 29.7424 8.13854 30.3398 8.13854C30.9373 8.13854 31.4237 7.64737 31.4237 7.04393C31.4306 6.44049 30.9443 5.94932 30.3398 5.94932Z"
        fill="white"
      />
      <path
        d="M30.3398 10.994C29.7424 10.994 29.256 11.4852 29.256 12.0886C29.256 12.692 29.7424 13.1832 30.3398 13.1832C30.9373 13.1832 31.4237 12.692 31.4237 12.0886C31.4237 11.4852 30.9443 10.994 30.3398 10.994Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-0.00012207 7.01226C-0.00012207 3.50773 2.84086 0.666748 6.34539 0.666748C9.84992 0.666748 12.6909 3.50773 12.6909 7.01226V24.6624C12.6909 28.1669 9.84992 31.0079 6.34539 31.0079C2.84086 31.0079 -0.00012207 28.1669 -0.00012207 24.6624V7.01226ZM1.81428 24.4637C1.87256 21.9268 3.95116 19.9171 6.45228 19.9762C8.95825 20.0353 10.9397 22.1436 10.8766 24.6804C10.8183 27.2173 8.73971 29.227 6.23859 29.1679C3.73747 29.1088 1.75601 27.0005 1.81428 24.4637ZM4.83289 26.217H7.86336V23.1432H4.83289V26.217ZM6.54893 2.61703C9.05143 2.67854 11.0343 4.78608 10.9777 7.32437C10.9212 9.86266 8.84671 11.8705 6.34421 11.809C3.84171 11.7475 1.85886 9.63994 1.91539 7.10166C1.97192 4.56337 4.04643 2.55553 6.54893 2.61703Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6398 17.8403V31.3336H31.9999V17.8403H18.6398ZM29.2854 27.6286H21.3583V25.9587H29.2854V27.6286ZM21.3583 23.2082H29.2854V21.5382H21.3583V23.2082Z"
        fill="white"
      />
    </svg>
  )
}
